import * as Constants from '../../../../../HelperMethods/constants';

const state = {
  rowData: [],
  isPageLoading: false,
  nextToken: null,
  currentView: Constants.ENGINE_LOGS_VIEW.ENGINE_ALL_LOGS_VIEW,
  selectedLog: null,
  users: [],
};

export default state;
